(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-custom-faqs-bands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-bracelets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-diamond"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.roa-diamond-container');
    if (!container) return 

    function loadDiamondContent() {
      const pathParts = window.location.pathname.replace(/^\/+|\/+$/g, '').split('/');
      const collectionHandle = pathParts[1];
      const diamondType = pathParts[2];

      if (!diamondType) return 

      const categoryMap = {
        'coloured-lab-grown-diamonds': 'coloured-lab-grown-diamonds',
        'lab-diamonds': 'lab-diamonds',
        'natural-diamonds': 'natural-diamonds',
      };
      const diamondCategory = categoryMap[collectionHandle];
      if (!diamondCategory) return 

      // Shape-keyed content only. Carat pages (0-30-carat-diamond etc.) have no entry in the
      // JSON below, so bail out and hide the block rather than render empty headings — this
      // also covers client-side navigation from a shape page to a carat page.
      const diamondShapes = ['asscher','cushion','emerald','heart','marquise','oval','pear','princess','radiant','round'];
      if (!diamondShapes.includes(diamondType.toLowerCase())) {
        container.style.display = 'none';
        return 
      }
      container.style.display = '';

      const diamondShape = diamondType.charAt(0).toUpperCase() + diamondType.slice(1);

      // --- static data setup (keep your staticData object here exactly as before) ---
      const staticData = {
        'coloured-lab-grown-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Lab-Grown Coloured Diamonds`,
          highlights: [
            'Australia’s Lowest Price for Certified Lab-Grown Coloured Diamonds',
            'IGI Certified for Quality and Authenticity',
            'FREE Custom Design – Personalise your ring with your favourite fancy colour',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia </a>`,
            'Fast Delivery (Under 4 Weeks)',
            `30% Off on <a href="https://ringsofaustralia.com.au/collections/coloured-lab-grown-diamonds" target="_blank" style="text-decoration:underline;">Lab-Grown Coloured Diamonds</a>`,
            `<a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Price Match Guarantee</a>`,
            'Sustainable, Ethical & Conflict-Free',
          ],
          specs: {
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            'Available Fancy Colours': 'Pink, Yellow, Blue, Red, and Green',
            Applications: `
            <a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank">Engagement Rings</a>, 
            <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank">Wedding Rings</a>, 
            Pendants,Earrings, Bracelets
            `,
            Occasions: 'Engagements, Anniversaries, Birthdays, Luxury Celebrations',
          },
          sizes: [
            { size: '1–2 Carat Pink / Yellow / Blue', bestFor: 'Elegant and minimalist engagement rings' },
            {
              size: '2–3 Carat Pink / Yellow / Blue',
              bestFor: 'Modern statement rings and fine jewellery',
            },
            { size: '3–5 Carat Pink / Yellow / Blue', bestFor: 'Luxurious, custom-designed creations' },
          ],
          sizeHeading: 'Popular Sizes & Fancy Colours',
        },
        'lab-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Lab-Grown Diamonds`,
          highlights: [
            'Lowest Price in Australia',
            'FREE Custom Design (Create your dream ring with our diamonds)',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia </a>`,
            'Fastest Delivery (Within 4 weeks)',
            `<a href="https://ringsofaustralia.com.au/pages/book-virtual-appointment" target="_blank" style="text-decoration:underline;">24/7 Customer Support </a>`,
            'Premium Quality & IGI Certified Diamonds',
            `30% Off on <a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Lab-Grown Diamonds</a>`,
            `<a href="https://ringsofaustralia.com.au/collections/lab-diamonds" target="_blank" style="text-decoration:underline;">Price Match Guarantee</a>`,
          ],
          specs: {
            'Diamond Cuts': 'Ideal, Excellent, Very Good, Good',
            'Diamond Colour': 'D, E, F, G, H, I, J, K',
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            Applications: `
            <a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank">Engagement Rings</a>, 
            <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank">Wedding Rings</a>, 
            Pendants,Earrings, Bracelets
            `,
          },
          sizes: [
            { size: '1 Carat', bestFor: 'Elegant and classic for engagement rings' },
            { size: '1.5 Carat', bestFor: 'Balanced and brilliant choice' },
            { size: '2 Carat', bestFor: 'Luxurious and eye-catching centrepiece' },
            { size: '3 Carat', bestFor: 'Statement piece for signature rings' },
            { size: '4–5 Carat', bestFor: 'Impressive size for custom designs' },
          ],
          sizeHeading: 'Popular Sizes',
        },
        'natural-diamonds': {
          title: `Why Choose Rings of Australia for ${diamondShape} Natural Diamonds`,
          highlights: [
            `Lowest Price for Certified<a href="https://ringsofaustralia.com.au/collections/natural-diamonds" target="_blank">Natural Diamonds </a>in Australia`,
            'GIA & IGI Certified for Authenticity and Quality',
            'FREE Custom Design (Create your dream ring with our natural diamonds)',
            `<a href="https://ringsofaustralia.com.au/pages/shipping" target="_blank">FREE Shipping Across Australia</a>`,
            'Fastest Delivery (Under 4 Weeks)',
            'Ethically Sourced & Conflict-Free Diamonds',
            `<a href="https://ringsofaustralia.com.au/pages/price-match-guarantee" target="_blank">Price Match Guarantee</a> on Natural Diamonds`,
          ],
          specs: {
            'Diamond Cuts': 'Ideal, Excellent, Very Good, Good',
            'Diamond Colour': 'D, E, F, G, H, I, J, K',
            'Diamond Clarity': 'FL, IF, VVS1, VVS2, VS1, VS2, SI1',
            Applications: `<a href="https://ringsofaustralia.com.au/collections/engagement-rings" target="_blank" style="text-decoration:underline;">Engagement Rings</a> <a href="https://ringsofaustralia.com.au/collections/womens-wedding-bands" target="_blank" style="text-decoration:underline;">Wedding Rings</a>Pendants, Earrings, Bracelets`,
          },
          sizes: [
            { size: '1 Carat', bestFor: 'Graceful and timeless choice for engagement rings' },
            { size: '1.5 Carat', bestFor: 'Elegant size with brilliant fire and balance' },
            { size: '2 Carat', bestFor: 'Luxurious option for classic and modern designs' },
            { size: '2.5 Carat', bestFor: 'Perfect for statement or heirloom jewellery' },
            { size: '3–5 Carat', bestFor: 'Striking brilliance for custom or high-end creations' },
          ],
          sizeHeading: 'Popular Sizes',
        },
      };
      const staticInfo = staticData[diamondCategory];
      if (!staticInfo) return 

      const staticHTML = `
      <div class="roa-container">
        <header class="roa-hero">
         <h2 class=" h3 roa-title">${staticInfo.title}</h2>
        </header>
        <div class="roa-highlights">
          <ul>${staticInfo.highlights.map((item) => `<li>${item}</li>`).join('')}</ul>
        </div>
        <section class="roa-specs">
          <h2 class="section-title">Our ${diamondShape} ${diamondCategory.replace(/-/g, ' ')} – Specifications</h2>
          <div class="spec-grid">
            ${Object.entries(staticInfo.specs)
              .map(
                ([key, val]) => `
                <div class="spec-item">
                  <h3>${key}</h3>
                  <p>${val}</p>
                </div>
              `
              )
              .join('')}
          </div>
        </section>
        <section class="roa-popular-sizes">
          <h2 class="section-title">${staticInfo.sizeHeading} for ${diamondShape} ${diamondCategory.replace(
        /-/g,
        ' '
      )}</h2>
          <div class="sizes-grid">
            ${staticInfo.sizes
              .map(
                (s) => `
                <div class="size-card">
                  <p class="size-name">${s.size} ${diamondShape} ${diamondCategory.replace(/-/g, ' ')}</p>
                  <p class="size-for"><strong>Best for:</strong> ${s.bestFor}</p>
                </div>`
              )
              .join('')}
          </div>
        </section>
      </div>
    `;

      const staticSection = document.querySelector('#roa-static-section');
      if (staticSection) staticSection.innerHTML = staticHTML;

      const jsonUrl = 'https://cdn.shopify.com/s/files/1/0900/1870/9868/files/diamond-faqs2.json?v=1764935173';
      fetch(jsonUrl)
        .then((res) => res.json())
        .then((data) => {
          const catObj = data[diamondCategory];
          const diamondData = catObj?.[diamondType];
          const faqsWrapper = container.querySelector('.roa-diamond-faqs');
          if (!diamondData) {
            if (faqsWrapper) faqsWrapper.style.display = 'none';
            return 
          }

          container.querySelector('.roa-diamond-title').textContent = diamondData.title;
          const paragraphContainer = container.querySelector('.roa-diamond-paragraphs');
          paragraphContainer.innerHTML = '';
          if (diamondData.paragraphs?.length > 0) {
            const firstPara = diamondData.paragraphs[0];
            const section = document.createElement('div');
            section.className = 'roa-diamond-paragraph';
            section.innerHTML = `<p>${firstPara.detail}</p>`;
            paragraphContainer.appendChild(section);
          }

          const faqList = container.querySelector('.roa-diamond-faq-list');
          faqList.innerHTML = '';
          if (faqsWrapper) faqsWrapper.style.display = diamondData.faqs?.length ? '' : 'none';

          (diamondData.faqs || []).forEach((faq) => {
            const faqItem = document.createElement('div');
            faqItem.className = 'roa-diamond-faq-item';
            const answerWithLink = faq.answer.replace(
              'FREE custom design',
              `<a href="/pages/customize-your-engagement-ring" class="faq-link">FREE custom design</a>`
            );
            faqItem.innerHTML = `
            <div class="roa-diamond-faq-question">${faq.question}<span>+</span></div>
            <div class="roa-diamond-faq-answer">${answerWithLink}</div>
          `;
            faqList.appendChild(faqItem);
          });

          faqList.querySelectorAll('.roa-diamond-faq-question').forEach((q) => {
            q.addEventListener('click', () => {
              const answer = q.nextElementSibling;
              const isActive = answer.classList.toggle('active');
              q.querySelector('span').textContent = isActive ? '–' : '+';
            });
          });
        })
        .catch((err) => console.error('❌ Error loading diamond data:', err));
    }

    // 🟢 Run once initially
    loadDiamondContent();

    // 🟢 Detect URL changes (works for SPA / Shopify Turbo / AJAX)
    let lastUrl = location.href;
    new MutationObserver(() => {
      const currentUrl = location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        loadDiamondContent();
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-earrings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-engagement-rings"] && !Shopify.designMode) return;
  try {
    /* Delegated rather than bound per element at DOMContentLoaded: switching setting style
     swaps in a different v-if branch, so Vue creates fresh question nodes that a one-off
     binding would never reach. Scoped to .er-faq-root so it only claims this snippet's
     questions and not the identically classed ones in the sibling FAQ snippets. */
  document.addEventListener('click', function (event) {
    const question = event.target.closest('.er-faq-root .faq-question');
    if (!question) return;

    const answer = question.nextElementSibling;
    if (!answer) return;

    const isOpen = answer.classList.toggle('active');
    const toggle = question.querySelector('.faq-icon');
    if (toggle) {
      toggle.innerHTML = isOpen ? `<i class="icon-minus"></i>` : `<i class="icon-plus"></i>`;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-fine-jewellery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-mens-bands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.h5').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynamic-custom-faqs-pendants"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach((item) => {
      item.addEventListener('click', () => {
        const answer = item.nextElementSibling;
        const toggle = item.querySelector('.faq-icon');

        // Toggle the answer
        answer.classList.toggle('active');

        // Toggle the icon
        toggle.innerHTML = answer.classList.contains('active')
          ? `<i class="icon-minus"></i>`
          : `<i class="icon-plus"></i>`;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
